import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({ gfm: true, breaks: true });

/**
 * Render markdown to HTML, sanitised with DOMPurify so it is safe to drop
 * into a Word/Excel/PowerPoint surface or render via dangerouslySetInnerHTML.
 * Strips <script>, on*= event handlers, javascript: URLs, etc.
 */
export function renderMarkdown(md: string): string {
  if (!md) return '';
  const raw = marked.parse(md, { async: false }) as string;
  return DOMPurify.sanitize(raw, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'iframe', 'object', 'embed', 'form'],
    FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick'],
  });
}
